'use client';
import { useEffect, useState } from 'react';

import { Ad } from '@ads/Components/Ad/Ad';
import { CarFinanceAd } from '@ads/Components/Ad/CarFinance/CarFinance';
import { buildPlpTargeting } from '@ads/Utils/BuildPlpTargeting';
import { tenantAtom } from '@core/Atoms/Tenant/Tenant.atom';
import { isWindowDefined } from '@core/Constants/Window';

import { Locale } from '@core/Entities/Locale/Locale.entity';
import { useAtomValue } from 'jotai';

import { useFilterListParams } from 'Hooks/SearchFilters/UseFiltersListParams';

import styles from './AdsPanel.module.css';

export const AdsPanel = ({ locale }: { locale: Locale }) => {
  const value = useFilterListParams({
    locale,
  });
  const [shouldShowAds, setShouldShowAds] = useState(false);
  const tenant = useAtomValue(tenantAtom);

  useEffect(() => {
    if (isWindowDefined) {
      setShouldShowAds(true);
    }
  }, []);

  const plpAdTargeting = value && buildPlpTargeting(value);

  return (
    <>
      {shouldShowAds && plpAdTargeting ? (
        <div className={styles.panelAds}>
          <Ad unitId="plpDmpu1" targeting={plpAdTargeting} stickyPadding={500} />
          {tenant && (
            <div className={styles.carFinanceWidget}>
              <CarFinanceAd />
            </div>
          )}
          <div className={styles.plpDmpuAdContainer}>
            <div className={styles.plpDmpuAd}>
              <Ad unitId="plpDmpu2" targeting={plpAdTargeting} withMargin />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
